import React from 'react';
import styles from './LandingSections.module.css';

function ContactCenterSection() {
  return (
    <section id="contacto" className={styles.contactCenterSection} aria-label="Centro de atención">
      <div className={styles.contactCenterInner}>
        <div className={styles.contactCenterImageWrap}>
          <img
            className={styles.contactCenterImage}
            src="/Ilustraciones/Ilustraciones_2.png"
            alt="Ilustración de contacto"
          />
        </div>
        <div className={styles.contactCenterContent}>
          <p className={styles.contactCenterHeading}>CENTRO DE ATENCIÓN</p>
          <p className={styles.contactCenterText}>
            Eugenio Garza Sada #701 Col. Lomas de Jesús María, Jesús María, Ags.
            <br />
            CP 20920
            <br />
            Correo de contacto: admin@uodm.com.mx
            <br />
            Teléfono de contacto: +52 56 1984 0693
          </p>
          <p className={styles.contactCenterHeading}>
            HORARIO DE ATENCIÓN Y RECEPCIÓN DE DOCUMENTOS:
          </p>
          <p className={styles.contactCenterText}>
            Lunes a viernes - 9am a 5pm
          </p>
        </div>
      </div>
    </section>
  );
}

export default ContactCenterSection;
